<template>
  <b-row class="justify-content-center py-5">
    <b-col
      md="6"
      sm="8"
    >
      <b-card
        no-body
        class="mx-4"
      >
        <b-card-body class="p-4">
          <h1>Forgot Password?</h1>
          <p class="text-muted">Let's fix that for you</p>

          <b-alert
            v-if="isSuccess"
            show
            variant="success"
          >Please check your email.</b-alert>

          <b-form
            v-else
            @submit.prevent="handleSubmit"
          >
            <NanInput
              v-model="login"
              :validation="$v.login"
              prependIcon="icon-user"
              placeholder="Username or email"
              aria-label="Username or email"
              class="mb-3"
            />

            <b-button
              id="login-password-reset_password"
              :class="{ 'disabled': $v.$invalid }"
              variant="primary"
              type="submit"
            >Reset Password</b-button>
          </b-form>

        </b-card-body>
        <b-card-footer class="p-4">
          <span class="text-muted">Already have an account?&nbsp;</span>
          <router-link
            id="login-password-login"
            :to="{ name: 'Login' }"
          >Login</router-link>
        </b-card-footer>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import API from "@/api";
import errMessages from "@/data/errors";

export default {
  mixins: [validationMixin],

  data: () => ({
    login: "",
    isSuccess: false
  }),

  methods: {
    async handleSubmit() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      this.$store.commit("REQUEST_INCREMENT");

      const { success } = await API.forgotPassword(this.login);

      this.$store.commit("REQUEST_DECREMENT");

      this.isSuccess = !!success;
    }
  },

  validations: {
    login: { required }
  }
};
</script>
